import { Schema } from '@micin-jp/chicken-schema'

export const parseChickenSchema = (schema: string) => {
  try {
    return JSON.parse(schema) as Schema
  } catch (error) {
    console.error(error)
    throw new Error('Schemaのパースに失敗しました')
  }
}
